import { createAsyncThunk } from '@reduxjs/toolkit'
import storefrontApiService from 'services/api/storefront-api-service'

export interface PaymentMethods {
  id: string
  type: string
  attributes: {
    type: string
    name: string
    description: string | null
  }
}

type GetPaymentMethodsParams =
  | {
      orderToken?: string
    }
  | undefined

export const getPaymentMethods = createAsyncThunk(
  'get-payment-methods',
  async ({ orderToken }: GetPaymentMethodsParams = {}, { rejectWithValue }) => {
    try {
      const data = await storefrontApiService.getPaymentMethods(orderToken)

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
